import { useStaticIntl } from '@tribeplatform/react-components/i18n'
import { useSpacesBySlugs } from '@tribeplatform/react-sdk/hooks'

import { convertToStatic } from '../../Views/utils'
import { staticFieldsFactory } from '../config'
import type { SpacesListBlockView } from '../types'
import { generateGqlFields } from '../utils/generateGqlFields'
import { EmptyState } from './EmptyState'
import { GenericSpacesList } from './GenericSpacesList'
import { LoadingState } from './LoadingState'

interface Props {
  view: SpacesListBlockView
  activeFieldId: string
  preview: boolean
}
export const SpecificSpacesList = ({
  view: { spaceSlugs, style, fields, gallerySize, showDivider },
  activeFieldId,
  preview,
}: Props) => {
  const staticFields = useStaticIntl(staticFieldsFactory)
  const mergedStaticFields = convertToStatic(fields, staticFields, [])

  const { data: spaces, isLoading } = useSpacesBySlugs({
    variables: { slugs: spaceSlugs },
    fields: generateGqlFields({ staticFields: mergedStaticFields, style }),
    useQueryOptions: {
      enabled: spaceSlugs?.length > 0,
    },
  })

  if (!spaceSlugs || spaceSlugs?.length === 0) {
    return <EmptyState />
  }

  if (!isLoading && spaces && spaces.length === 0) {
    return <EmptyState />
  }

  if (isLoading || !spaces) {
    return (
      <LoadingState
        count={spaceSlugs.length}
        style={style}
        gallerySize={gallerySize}
        showDivider={showDivider}
      />
    )
  }

  return (
    <GenericSpacesList
      style={style}
      spaces={spaces}
      fields={mergedStaticFields}
      gallerySize={gallerySize}
      showDivider={showDivider}
      activeFieldId={activeFieldId}
      showMoreButton={null}
      preview={preview}
    />
  )
}
